module.exports = __webpack_public_path__ + "img/countyClerkLogo.34384798.svg";